import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmailTemplateGalleryPage from "@/pages/admin/EmailTemplateGalleryPage";

export const Route = createFileRoute("/_admin/admin/email-gallery")({
  head: () => pageHead("Admin · Email Gallery", "AKIVA admin · email gallery portal.", "/admin/email-gallery", true),
  component: EmailTemplateGalleryPage,
});
